<template>
  <div id="app">
    <wz-loader v-if="isLoading">
      <template #brand>
        <CrystalLogo :size="36" />
        <span class="app-loader-name">Crystal</span>
      </template>
    </wz-loader>
    <router-view/>
    <DocumentComplianceModal />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DocumentComplianceModal from '@/core/components/DocumentComplianceModal.vue'
import CrystalLogo from '@/core/components/icons/CrystalLogo.vue'

export default {
  components: { DocumentComplianceModal, CrystalLogo },
  mounted() {
    document.documentElement.style.setProperty('--color-primary', '#0288D1')
    document.documentElement.style.setProperty('--color-primary-dark', '#0277BD')
    document.documentElement.style.setProperty('--admin-primary-color', '#0288D1')
    document.documentElement.style.setProperty('--admin-primary-hover', '#0277BD')
    document.documentElement.style.setProperty('--admin-secondary-color', '#29B6F6')
    document.documentElement.style.setProperty('--admin-bg-active', 'rgba(2, 136, 209, 0.15)')
  },
  computed: {
    ...mapGetters({ isLoading: 'app/isLoading' })
  }
}
</script>

<style>
</style>
